export default __webpack_public_path__ + "static/media/negative.1a22d878.svg";